import React from "react";
import Field from "../shared/Field";
import { inputStyle } from "../shared/inputStyle";

export default function CriminalForm({
  criminalTier,
  setCriminalTier,
  repeatCounts,
  setRepeatCounts,
}) {
  return (
    <div className="space-y-5">
      <Field label="نوع جرم">
        <select
          value={criminalTier}
          onChange={(e) => setCriminalTier(e.target.value)}
          className="input"
          style={inputStyle}
        >
          <option value="minor">
            شلاق / جزای نقدی / سرقت حدی / حبس کمتر از ۱۰ سال
          </option>
          <option value="major">
            قصاص نفس / محاربه / حدود مستوجب قتل / حبس ۱۰ سال و بیشتر
          </option>
          <option value="other">سایر دعاوی غیرمالی کیفری</option>
        </select>
      </Field>
      {criminalTier !== "other" && (
        <Field label="تعداد عناوین تعدد جرم (حداکثر ۳ عنوان محاسبه می‌شود)">
          <input
            type="number"
            min={0}
            max={10}
            value={repeatCounts}
            onChange={(e) => setRepeatCounts(Number(e.target.value))}
            className="input"
            style={inputStyle}
          />
        </Field>
      )}
    </div>
  );
}
